<template>
  <main-layout
    class="insurance"
    :page-title="title"
    @listen-back="goBack"
    customBack
    v-loading="loading"
  >
    <div slot="main-content" class="main-content">
      <component
        :handleTitle.sync="title"
        :is="currentStep"
        ref="InsureJS"
        @buyInsure="buyInsure"
      ></component>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import ruralContent from "@/views/ruralInsurance/introduce/ruralContent.vue";
import { getStorage, SessionStorage } from "@/utils/storage";
//
import { ruralInsurance, checkEnableInsure } from "@/api/request/snkd.produce";
import { mapState } from "vuex";

export default {
  name: "Introduce",
  components: { MainLayout, ruralContent },
  data() {
    return {
      currentStep: "ruralContent",
      // 险种名称
      title: "",
      // 险种ID
      insuranceId: 2,
      // 判断来的页面
      pathWhere: getStorage("pathWhere") ? getStorage("pathWhere") : "",
      // 是否有订单列表
      listHave: [],
      // 是否显示页面
      isshow: false,
      loading: false,
      ruralInsuranceLength: null,
      insureInfo: {},
    };
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },

  created() {
    this.getRuralLists();
  },
  mounted() {},
  methods: {
    // 立即投保
    async buyInsure() {
      this.insureInfo = SessionStorage.get("insureInfo");

      const res = await checkEnableInsure({
        insureId: this.$refs.InsureJS.list.find(
          (item) => item.id === this.insureInfo.id
        ).id,
        companyId: this.companyId,
        farmId: this.farmId,
      });
      if (res && res.respCode == 0) {
        this.$router.push("/ruralWriteInfo");
      }
    },
    // 获取穗优保险订单列表 --->
    async getRuralLists() {
      this.loading = true;
      const { respCode, obj } = await ruralInsurance.getRuralList({
        companyId: this.companyId,
        farmId: this.farmId,
        pageNo: 1,
        pageSize: 20,
      });
      if (respCode === 0) {
        this.ruralInsuranceLength = obj.length;
        this.loading = false;
        this.isshow = true;
      }
    },
    // 返回上一级跳转到列表页  判断返回页面
    goBack() {
      window.history.go(-1);
      // if (this.ruralInsuranceLength) {、
      //从列表页跳转到保险介绍页
      //   window.history.go(-1);
      // } else {
      //   // 回到主页insuranceList
      //           windowHref("/home/home");
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.insurance {
  .main-content {
    min-height: calc(100% - 80px);
    height: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
}

::v-deep .common-page-header .title {
  font-size: 22px !important;
  width: 400px;
}
</style>
